{
  "name": "ontime",
  "version": "4.12.0",
  "description": "Time keeping for live events",
  "keywords": [
    "ontime",
    "timer",
    "rundown"
  ],
  "author": "Carlos Valente",
  "homepage": "https://www.getontime.no/",
  "repository": "https://github.com/cpvalente/ontime",
  "bugs": {
    "url": "https://github.com/cpvalente/ontime/issues",
    "email": "mail@getontime.no"
  },
  "license": "AGPL-3.0-only",
  "engines": {
    "node": "~22",
    "pnpm": "~11"
  },
  "type": "module",
  "scripts": {
    "dev": "turbo run dev",
    "dev:prefix": "cross-env ROUTER_PREFIX=test cross-env IS_CLOUD=True turbo run dev --filter=ontime-server",
    "dev:electron": "turbo run dev:electron",
    "lint": "turbo run lint",
    "typecheck": "turbo run typecheck",
    "build": "turbo run build",
    "build:docker": "cross-env NODE_ENV=docker turbo run build --filter=ontime-server --filter=ontime-ui",
    "build:resolver": "turbo run build --filter=@getontime/resolver",
    "dist-win": "turbo run dist-win --filter=ontime-electron",
    "dist-mac": "turbo run dist-mac --filter=ontime-electron",
    "dist-linux": "turbo run dist-linux --filter=ontime-electron",
    "e2e": "turbo run build --filter=ontime-ui && pnpm clear-temp && cross-env DEBUG=pw:webserver pnpm playwright test -c playwright.config.ts",
    "e2e:ui": "cross-env NODE_ENV=development cross-env DEBUG=pw:webserver pnpm playwright test --ui -c playwright.config.ts",
    "e2e:i": "pnpm playwright codegen",
    "clear-temp": "rimraf e2e/tests/fixtures/tmp",
    "test": "turbo run test:pipeline",
    "format": "oxfmt",
    "format:check": "oxfmt --check"
  },
  "devDependencies": {
    "@playwright/test": "1.60.0",
    "@types/node": "catalog:",
    "cross-env": "^7.0.3",
    "oxfmt": "^0.42.0",
    "oxlint": "^1.57.0",
    "oxlint-tsgolint": "^0.17.4",
    "rimraf": "catalog:",
    "turbo": "2.8.20",
    "typescript": "catalog:"
  },
  "packageManager": "pnpm@11.1.2+sha512.415a1cc25974731e75455c1468371be74c5aa5fb7621b50d4056d222451609f11412f23fd602e6169f1e060466641f798597e1be961a10688836a67b16569499",
  "devEngines": {
    "runtime": {
      "name": "node",
      "version": "22.22.3"
    }
  }
}
